<template>
  <div>
    <header id="container">
      <div class="left">
        <img class="logo" @click="$router.push('/')" src="/static/img/personalCenter/jgw-new-logo.png" alt="">
        <div class="nav">
          <div :class="headerNavIndex==1?'navItem select':'navItem'" @click="selectNav(1)">
            买家中心
            <img class="PersonalCenter-navSelect" src="/static/img/personalCenter/PersonalCenter-navSelect.png" alt="">
          </div>
          <div v-if="showShopUser" :class="headerNavIndex==2?'navItem select':'navItem'" @click="selectNav(2)">
            卖家中心
            <img class="PersonalCenter-navSelect" src="/static/img/personalCenter/PersonalCenter-navSelect.png" alt="">
          </div>
        </div>
      </div>
      <div class="right" @mouseleave="unfold = false">
        <div class="toIndex-box" @click="$router.push('/')">
          <img class="PersonalCenter-indexIcon" src="/static/img/personalCenter/PersonalCenter-indexIcon.png" alt="">
          <div class="toIndex">首页</div>
        </div>
        <img class="line" src="/static/img/personalCenter/PersonalCenter-line.png" alt="">
        <div class="account">{{userInfo.username}}</div>
        <img :class="unfold?'PersonalCenter-unfold unfold':'PersonalCenter-unfold'"
          @click="unfold = true"
          src="/static/img/personalCenter/PersonalCenter-unfold.png" alt="">
        <div :class="unfold?'unfoldContent unfoldContent-show':'unfoldContent'" @mouseleave="unfold = false">
          <div class="item" @click="signOut">
            <img src="/static/img/personalCenter/PersonalCenter-logout.png" alt="">
            退出账号
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'PersonalCenterHeader',
  data () {
    return {
      userInfo:{username:''},
      unfold: false,
      buyer:[//已弃用，在新加页面的时候去store中加
        'PersonalCenter',//我的订单
        'PersonalCenterDetail',
        'PersonalCenterBuyerSupply',//供应信息
        'PersonalCenterPurchaseMessage',//求购信息
        'PersonalPurchaseOrderDetail',
        'PersonalCenterBrokerInfo',//经纪人信息
        'PersonalCompanyInfo',//基本信息
        'PersonalAccounts',//账户安全
        'PersonalReceiveAddress',//收货地址管理
        'PersonalPassword',
        'Personalforgotpassword',
        'PersonalFixpassword',
        'PersonalOrderDetail',
        'Personalsuccess',
        'PersonalReceiveAddress',
        'PersonalPurchaseOrder',
        'PersonalPurchaseAfterSales',
        'PersonalPurchaseAfterSalesDetail',
        'PersonalPurchaseContract',
        'PersonalPurchaseInvoice',
        'PersonalPurchaseInvoiceDetail',
        'PersonalPurchaseCollect',
        'PersonalMyproperty',
        'PersonalMymessage',
        'PersonalLeaveAmessage',
        'PersonalRealNameAuthentication'
      ],
      seller:[//已弃用，在新加页面的时候去store中加
        'PersonalSaleOrder',//我的销售订单
        'PersonalCommodityManagement',//商品管理
        'PersonalStoreInfo',//店铺信息管理
        'PersonalSellerOrderDetail',
        'PersonalAddProduct',
        'PersonalAfterSalesManagement',//售后管理
        'PersonalInvoiceManagement',//发票管理
        'PersonalContractManagement',//合同管理
        'PersonalEvaluationList',//交易评价
        'PersonalMerchantManagement',//商家设置 物流公司
        'PersonalLogisticsSetup',//商家设置 物流管理
        'PersonalWarehouseManagement',//仓库管理
        'PersonalLogisticsManagement',//配送调拨
        'PersonalBusinessStatistics'//统计
      ]
    };
  },
  computed:{
    showShopUser(){
      return this.$store.state.shopUser
    },
    headerNavIndex: {
      get(){
        return this.$store.state.headerNavIndex
      },
      set(v){
        this.$store.state.headerNavIndex = v
      }
    }
  },
  mounted(){
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || this.$options.data().userInfo
  },
  methods: {
    selectNav(v){
      if(v==this.headerNavIndex)return
      this.headerNavIndex = v
      this.$emit('selectNav',v)
      this.$store.state.headerNavChangeType = 'click'
    },
    signOut(){
      // 退出登陆
      this.$store.dispatch('signOut').then(res => {
        this.$router.push({path: '/UserLogin'});
      }).catch(err => {
        console.log(err);
      });
    }
  },
  watch:{
    '$route':{
      immediate: true,
      handler(v){
        if(!v.name)return
        let res = false
        this.$store.state.buyer.some((i, index) => {
          i.some((i2) => {
            if (i2 == v.name) {
              res = true;
              this.headerNavIndex = 1;
            }
          });
        });
        if(!res){
          this.$store.state.seller.some((i,index)=>{
            i.some((i2) => {
            if (i2 == v.name) {
              this.headerNavIndex = 2;
            }
          });
          })
        }
        // console.log('$route.name',v.name,this.headerNavIndex);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_common.scss";
#container {
  width: 100%;
  height: 60px;
  background-color: $mainColor;
  display: flex;
  justify-content: space-between;
  >div {
    height: 100%;
  }
  .left {
    display: flex;
    padding-left: 16px;
    height: 100%;
    .logo {
      width: 104px;
      height: 60px;
      cursor: pointer;
    }
    .nav {
      height: 100%;
      display: flex;
      margin-left: 80px;
      .navItem {
        height: 100%;
        width: 104px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        font-size: 18px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        cursor: pointer;
        >img {
          display: none;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 20px;
          height: 8px;
        }
        &:hover {
          background-color: rgba(51,51,51,0.08);
        }
        &:first-child {
          margin-right: 20px;
        }
      }
      .select {
        font-weight: 700;
        img {
          display: block;
        }
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 16px;
    .toIndex-box {
      display: flex;
      cursor: pointer;
      &:hover {
        .toIndex {
          border-bottom: 1px solid rgba(255,255,255,0.92);
      }
      }
    }
    .PersonalCenter-indexIcon {
      height: 14px;
      width: 14px;
      margin-right: 6px;
    }
    .line {
      height: 10px;
      width: 10px;
      margin: 0 16px;
    }
    .PersonalCenter-unfold {
      height: 12px;
      width: 12px;
      margin: 0 20px 0 8px;
      cursor: pointer;
      transform: rotate(180deg);
      transition: all 0.3s linear;
    }
    .unfold {
      transform: rotate(0);
    }
    .unfoldContent {
      position: absolute;
      right: 20px;
      width: 110px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 3px 3px 3px 3px;
      padding: 6px;
      opacity: 1;
      bottom: -40px;
      box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.12), 0px 4px 5px 0px rgba(0,0,0,0.08), 0px 1px 10px 0px rgba(0,0,0,0.05);
      border: 1px solid #DCDCDC;
      transition: all 0.3s linear;
      visibility: hidden;
      opacity: 0;
    }
    .unfoldContent-show {
      visibility: visible;
      opacity: 1;
    }
    .item {
      width: 98px;
      height: 28px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      cursor: pointer;
      &:hover {
        background-color: #F3F3F3;
      }
      img {
        height: 16px;
        width: 16px;
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personalCenterComponents/PersonalCenterHeader.vue